var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { ref: "container", staticClass: "pb-5 bg-white" },
    [
      _c(
        "LoadingOverlay",
        { attrs: { hasData: !!_vm.contractors, loading: _vm.loading } },
        [
          _c(
            "div",
            { staticClass: "mx-6" },
            [
              _c("ContractorCollectionFilters", {
                attrs: {
                  currentUserId: _vm.currentUser.id,
                  hideManagersFilter: _vm.isManager,
                  filters: _vm.directoryFilters,
                  parentInputClass: "pb-6",
                  filterClass: "w-max-content",
                },
                on: {
                  filtersChanged: _vm.updateFilters,
                  resetFilters: _vm.resetFilters,
                },
              }),
            ],
            1
          ),
          _c("EmptyListPlaceholder", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isEmpty,
                expression: "isEmpty",
              },
            ],
            attrs: { title: _vm.emptyListTitle },
            scopedSlots: _vm._u([
              {
                key: "image",
                fn: function () {
                  return [_c("EmptyListImageContractors")]
                },
                proxy: true,
              },
            ]),
          }),
          _c(
            "div",
            [
              _c(
                "div",
                { staticClass: "flex flex-wrap gap-4 p-4 pt-0" },
                _vm._l(_vm.contractors, function (contractor) {
                  return _c("ContractorCard", {
                    key: contractor.id,
                    attrs: {
                      avatar: contractor.user.avatar,
                      companyId: _vm.companyId,
                      experience: contractor.user.experiences,
                      tasks:
                        contractor.project_activities_aggregate.aggregate.count,
                      companyNotifications:
                        contractor.user.company_notifications,
                      contractorId: contractor.id,
                      contractorUserId: contractor.user.id,
                      currentUserId: _vm.currentUser.id,
                      currentUserRole: _vm.currentUser.role,
                      currentUserManagerId: _vm.currentUserManagerId,
                      currency: contractor.user.profile.currency,
                      familyName: contractor.user.family_name,
                      favorited: contractor.user.favorited_by_users,
                      givenName: contractor.user.given_name,
                      jobTitle: _vm.getOccupation(contractor),
                      companyName: contractor.user.profile.company_name,
                      location: _vm.getLocation(contractor.user.profile),
                      managers: contractor.managers,
                      rateUnit: contractor.user.profile.rate_unit,
                      maxRate: contractor.user.profile.max_rate,
                      minRate: contractor.user.profile.min_rate,
                      skills: contractor.user.profile.skills,
                      emailConfirmed: contractor.user.confirmed,
                      userUpdatedDate: contractor.user.updated_at,
                      contractors: [contractor],
                      managerAccessApproved:
                        _vm.isManagerAccessApproved(contractor),
                      absoluteDetailsLinkPath: "",
                    },
                    on: {
                      message: _vm.message,
                      refetch: function ($event) {
                        return _vm.$apollo.queries.contractors.refetch()
                      },
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "rating",
                          fn: function () {
                            return [
                              _c("ContractorRating", {
                                staticClass:
                                  "flex items-center justify-center w-full mt-4 mb-1",
                                attrs: {
                                  ratingTotal: contractor.ratingTotal,
                                  ratingCount:
                                    contractor.ratingTotal.aggregate.count,
                                },
                              }),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      true
                    ),
                  })
                }),
                1
              ),
              _c("CardPagination", {
                attrs: { config: _vm.paginationConfig },
                on: {
                  "update:config": function ($event) {
                    _vm.paginationConfig = $event
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }